module.exports = "<p>\r\n  profilesuccess works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Joey/Desktop/testdeploy/mk2/FindMeHireMe/src/app/profilesuccess/profilesuccess.component.html
// module id = ../../../../../src/app/profilesuccess/profilesuccess.component.html
// module chunks = main